import { useContext, useEffect, useRef } from 'react';
import { Timestamp } from 'firebase/firestore';
import { MessageContext } from '../providers/MessageContext';
import { Notification } from '#types/System.types';

type UseNotificationToastsParams = {
    unreadNotifications: Notification[];
};

export const useNotificationToasts = ({ unreadNotifications }: UseNotificationToastsParams) => {
    const { messageApi } = useContext(MessageContext);
    const previousUnreadNotificationIds = useRef<Set<string>>(new Set());

    useEffect(() => {
        const currentNotifications = unreadNotifications;
        const currentIds = new Set<string>();
        const newNotifications: Notification[] = [];

        if (!messageApi) return;

        currentNotifications.forEach((notification) => {
            const eventId = notification.notificationEvent?.docId;
            if (!eventId) {
                return;
            }
            currentIds.add(eventId);
            if (!previousUnreadNotificationIds.current.has(eventId)) {
                newNotifications.push(notification);
            }
        });

        if (previousUnreadNotificationIds.current.size > 0 && newNotifications.length > 0) {
            newNotifications
                .sort((a, b) => (b.timestamp as Timestamp).toMillis() - (a.timestamp as Timestamp).toMillis())
                .forEach((notification) => {
                    if (!notification?.notificationEvent) return;
                    
                    const changeType = notification.notificationEvent.changeType;
                    const message = notification.notificationEvent.message;
                    const relatedUri = notification.notificationEvent.relatedUri;

                    if (changeType === 'FORM_REMINDER') {
                        messageApi.open({
                            type: 'info',
                            content: message,
                            duration: 0,
                            onClick: relatedUri ? () => window.location.href = relatedUri : undefined,
                            style: { cursor: relatedUri ? 'pointer' : 'default' },
                        });
                    } else {
                        messageApi.info({
                            content: message,
                            duration: 4,
                            onClick: relatedUri ? () => window.location.href = relatedUri : undefined,
                            style: { cursor: relatedUri ? 'pointer' : 'default' },
                        });
                    }
                });
        }

        previousUnreadNotificationIds.current = currentIds;
    }, [unreadNotifications, messageApi]);
};
